<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-truck-plane"></i></span
    >{{ "Menu.Menu.RFQMaintenance" | translate }}
  </h1>
  <p-card>
    <p-accordion (onOpen)="accordionTabOpen()">
      <p-accordionTab
        header="{{ 'RFQMaintenance.Search.RFQQuery' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "RFQMaintenance.Search.Forwarder" | translate }}</label>
              <p-multiSelect
                formControlName="forwarderList"
                optionLabel="label"
                optionValue="value"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [options]="forwarderOptions"
                [filter]="true"
                filterBy="label"
              >
              </p-multiSelect>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "RFQMaintenance.Search.RFQNum" | translate }}</label>
              <div class="formgrid grid">
                <div class="col">
                  <p-inputNumber formControlName="startSeqNo"></p-inputNumber>
                </div>
                ~
                <div class="col">
                  <p-inputNumber formControlName="endSeqNo"></p-inputNumber>
                </div>
              </div>
            </div>

            <!-- 起運地位置選擇 -->
            <laas-location-cascade-dropdown
              formControlName="fromLocation"
              [showCountry]="true"
              [showCity]="true"
              [showArea]="true"
              [showExpressArea]="true"
              countryLabel="{{
                'RFQMaintenance.Search.OriginCountry' | translate
              }}"
              cityLabel="{{ 'RFQMaintenance.Search.OriginCity' | translate }}"
              areaLabel="{{ 'RFQMaintenance.Search.OriginArea' | translate }}"
              expressAreaLabel="{{
                'RFQMaintenance.Search.OriginCourierCity' | translate
              }}"
              districtLabel="{{
                'AddressMaintain.Form.AssignmentDistrict' | translate
              }}"
              countryPlaceholder="{{
                'Common.Message.ChooseOption' | translate
              }}"
              cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              expressAreaPlaceholder="{{
                'Common.Message.ChooseOption' | translate
              }}"
              [allowAllOption]="true"
              (countryOptionsReady)="onCountryOptionsReady($event)"
              (cityOptionsReady)="onCityOptionsReady($event)"
              (areaOptionsReady)="onAreaOptionsReady($event)"
              (expressAreaOptionsReady)="onExpressAreaOptionsReady($event)"
              (selectionComplete)="onFromLocationComplete($event)"
            >
            </laas-location-cascade-dropdown>

            <!-- 目的地位置選擇 -->
            <laas-location-cascade-dropdown
              formControlName="toLocation"
              [showCountry]="true"
              [showCity]="true"
              [showArea]="true"
              [showExpressArea]="true"
              countryLabel="{{
                'RFQMaintenance.Search.DestinationCountry' | translate
              }}"
              cityLabel="{{
                'RFQMaintenance.Search.DestinationCity' | translate
              }}"
              areaLabel="{{
                'RFQMaintenance.Search.DestinationArea' | translate
              }}"
              expressAreaLabel="{{
                'RFQMaintenance.Search.DestinationCourierCity' | translate
              }}"
              districtLabel="{{
                'AddressMaintain.Form.AssignmentDistrict' | translate
              }}"
              countryPlaceholder="{{
                'Common.Message.ChooseOption' | translate
              }}"
              cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              expressAreaPlaceholder="{{
                'Common.Message.ChooseOption' | translate
              }}"
              [allowAllOption]="true"
              (selectionComplete)="onToLocationComplete($event)"
            >
            </laas-location-cascade-dropdown>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "RFQMaintenance.Search.Status" | translate }}</label>
              <div class="item">
                <p-multiSelect
                  formControlName="statusList"
                  optionLabel="label"
                  optionValue="value"
                  [options]="rfqStatusOptions"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [filter]="true"
                  styleClass="p-text-left"
                >
                </p-multiSelect>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label
                >{{ "RFQMaintenance.Search.Effective" | translate }}
              </label>
              <div class="item">
                <p-dropdown
                  formControlName="isActivated"
                  optionLabel="label"
                  optionValue="value"
                  [options]="yesNoOption"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  styleClass="p-text-left"
                >
                </p-dropdown>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <div class="mb-1">
                {{ "RFQMaintenance.Search.DocumentType" | translate }}
              </div>
              <p-multiSelect
                formControlName="rfqCategoryList"
                optionLabel="label"
                optionValue="value"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [options]="rfqCategoryTypeOptions"
                [filter]="true"
                filterBy="label"
              >
              </p-multiSelect>
            </div>

            <div class="col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                #effectDate
                [title]="'RFQMaintenance.Search.EffectiveDate'"
                [enableMaxDateIsToday]="false"
                [defaultDate]="defaultEffectDate"
                [showRangeMode]="true"
                [showStartMode]="true"
                [monthRange]="12"
                (onDateChange)="dateOnChange($event, 'effectDate')"
              >
              </laas-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <div class="mb-1">
                {{ "RFQMaintenance.Search.Customer" | translate }}
              </div>
              <div class="item">
                <laas-customer-dropdown
                  formControlName="consigneeKey"
                  [isSingle]="true"
                  [showClear]="true"
                  [divClass]="'p-text-left p-fluid'"
                >
                </laas-customer-dropdown>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{
                "RFQMaintenance.Search.ShippingMethod" | translate
              }}</label>
              <div class="item">
                <p-dropdown
                  formControlName="shippingType"
                  optionLabel="label"
                  optionValue="value"
                  [options]="shippingTypeOptions"
                  [showClear]="true"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [filter]="true"
                  styleClass="p-text-left"
                >
                </p-dropdown>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "RFQMaintenance.Search.TradeTerm" | translate }}</label>
              <div class="item">
                <p-dropdown
                  #dd
                  formControlName="incoTerm"
                  optionLabel="label"
                  optionValue="value"
                  [options]="incoTermOptions"
                  [showClear]="true"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [filter]="true"
                  styleClass="p-text-left"
                >
                </p-dropdown>
              </div>
            </div>

                    <div class="col-12 md:col-6 lg:col-3 mb-3">
                      <label>{{ 'RFQMaintenance.Search.Facility' | translate }}</label>
                      <div class="item">
                        <laas-facility-dropdown
                          formControlName="facilityList"
                          [isMultiple]="true"
                          [showFilter]="true"
                          [showToggleAll]="true">
                        </laas-facility-dropdown>
                      </div>
                    </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label
                >{{ "RFQMaintenance.Search.IsConsolidation" | translate }}
              </label>
              <div class="item">
                <p-dropdown
                  formControlName="isConsolidation"
                  optionLabel="label"
                  optionValue="value"
                  [options]="isConsolidationOptions"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  styleClass="p-text-left"
                >
                </p-dropdown>
              </div>
            </div>
          </div>

          <div class="grid">
            <div class="col">
              <button
                pButton
                pRipple
                label="{{ 'RFQMaintenance.Button.Query' | translate }}"
                (click)="searchRfq()"
              ></button>
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Reset' | translate }}"
                (click)="resetClickBtn($event)"
                class="p-button-secondary ml-4"
              ></button>
              <laas-permission-button
                permissionCode="CreateRFQ"
                label="{{ 'RFQMaintenance.Button.New' | translate }}"
                (onClick)="addBtn()"
                [class]="'ml-4'"
              ></laas-permission-button>
              <laas-permission-button
                permissionCode="CreateRFQ"
                label="{{ 'RFQMaintenance.Button.Import' | translate }}"
                (onClick)="uploadRFQBtn()"
                [class]="'ml-4'"
              ></laas-permission-button>
              <button
                pButton
                pRipple
                label="{{ 'RFQMaintenance.Button.Export' | translate }}"
                (click)="getRFQExcel()"
                class="ml-4"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <div class="mt-2">
      <laas-data-table
        [expandable]="true"
        (rowExpanded)="searchDetailClick($event)"
        [selectable]="true"
        [tableKey]="preferenceKey"
        [(selectedRows)]="selectedRfqData"
        [dataKey]="'seqNo'"
        [value]="searchResults"
        [defaultColumns]="columns"
        [loading]="isLoading"
      >
        <ng-template pTemplate="caption">
          <laas-permission-button
            permissionCode="BtnRFQApply"
            label="{{ 'RFQMaintenance.Button.Apply' | translate }}"
            (onClick)="applyClickBtn($event)"
            [class]="'ml-2'"
          ></laas-permission-button>
          <laas-permission-button
            permissionCode="BtnRFQRecall"
            label="{{ 'RFQMaintenance.Button.Withdraw' | translate }}"
            (onClick)="withdrawClickBtn($event)"
            [class]="'p-button-secondary ml-2'"
          ></laas-permission-button>
          <laas-permission-button
            permissionCode="BtnRFQDelete"
            label="{{ 'RFQMaintenance.Button.Delete' | translate }}"
            (onClick)="deleteClickBtn($event)"
            [class]="'p-button-secondary ml-2'"
          ></laas-permission-button>
          <laas-permission-button
            permissionCode="BtnRFQApproved"
            label="{{ 'RFQMaintenance.Button.Approved' | translate }}"
            (onClick)="approveClickBtn($event)"
            [class]="'ml-2'"
          ></laas-permission-button>
          <laas-permission-button
            permissionCode="BtnRFQInvalid"
            label="{{ 'RFQMaintenance.Button.Void' | translate }}"
            (onClick)="cancelClickBtn($event)"
            [class]="'p-button-secondary ml-2'"
          ></laas-permission-button>
          <laas-permission-button
            label="{{ 'RFQMaintenance.Button.Download' | translate }}"
            [disabled]="showRFQDownloadBtn"
            (onClick)="downloadClickBtn($event)"
            [class]="'ml-2'"
          ></laas-permission-button>
        </ng-template>

        <ng-template
          pTemplate="body"
          let-rowData
          let-columns="columns"
          let-expanded="expand"
        >
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'seqNo'">
                <div class="overflow-text">
                  <a
                    href="javascript: void(0);"
                    (click)="seqNoLinkClick($event, rowData)"
                    >{{ rowData[col.field] }}</a
                  >
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'forwarder'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]  | replaceNullWith : "-"
                      | optionsMapping : forwarderOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'status'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] | replaceNullWith : "-"
                      | optionsMapping : rfqStatusOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'fromCountry'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]  | replaceNullWith : "-"
                      | optionsMapping : countryOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'fromCity'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] | replaceNullWith : "-"
                      | optionsMapping : allCityOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'fromArea'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] | replaceNullWith : "-"
                      | optionsMapping : allAreaOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'toCountry'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] | replaceNullWith : "-"
                      | optionsMapping : countryOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'toCity'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] | replaceNullWith : "-"
                      | optionsMapping : allCityOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'toArea'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]  | replaceNullWith : "-"
                      | optionsMapping : allAreaOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'rfqCategory'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] | replaceNullWith : "-"
                      | optionsMapping : rfqCategoryTypeOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'shippingType'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] | optionsMapping : shippingTypeOptions
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'isConsolidation'">
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'expressTerm'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]  | replaceNullWith : "-"
                      | optionsMapping : expressTermOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'awbAddress'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]  | replaceNullWith : "-"
                      | optionsMapping : pickupLocationOptions

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'effectStartDate'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]  | replaceNullWith : "-"
                      | date : "yyyy-MM-dd" : this.laasSetting.facilityTimeZone

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'effectEndDate'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]  | replaceNullWith : "-"
                      | date : "yyyy-MM-dd" : this.laasSetting.facilityTimeZone

                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'isActivated'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]  | replaceNullWith : "-"
                      | optionsMapping : yesNoOption
                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'createDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'updateDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>

        <ng-template
          pTemplate="rowexpansion"
          let-rowData
          let-rowIndex="rowIndex"
        >
          <laas-data-table
            [tableKey]="preferenceKey2"
            [value]="rowData.rfqDetails"
            [defaultColumns]="detailColumns"
            [loading]="isLoading"
            [paginator]="false"
            [style]="{ 'overflow-y': 'auto' }"
          >
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <td *ngFor="let col of columns">
                <div [ngSwitch]="col.field">
                  <ng-container *ngSwitchCase="'feeType'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | optionsMapping : feeTypeOptions }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'incoTerm'">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping : incoTermOptions
                          | replaceNullWith : "-"
                      }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'shippingSectionDesc'">
                    <div class="overflow-text">
                      {{ rowData[col.field] }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'currency'">
                    <div class="overflow-text">
                      {{
                        rowData[col.field] | optionsMapping : currencyOptions
                      }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'unitPrice'">
                    <div class="overflow-text">
                      {{ rowData[col.field] }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'calculationUnit'">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping : calculationUnitOptions
                      }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'intervalUnitStart'">
                    <div class="overflow-text">
                      {{ rowData[col.field] }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'intervalUnitEnd'">
                    <div class="overflow-text">
                      {{ rowData[col.field] }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'minimalCharge'">
                    <div class="overflow-text">
                      {{ rowData[col.field] }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'remark'">
                    <div class="overflow-text">
                      {{ rowData[col.field] }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'isTieredGroup'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | optionsMapping : yesNoOption }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'createUser'">
                    <div class="overflow-text">
                      {{ rowData[col.field] }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'createDt'">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | date
                            : "yyyy-MM-dd HH:mm:ss"
                            : this.laasSetting.facilityTimeZone
                      }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'updateUser'">
                    <div class="overflow-text">
                      {{ rowData[col.field] }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'updateDt'">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | date
                            : "yyyy-MM-dd HH:mm:ss"
                            : this.laasSetting.facilityTimeZone
                      }}
                    </div>
                  </ng-container>
                </div>
              </td>
            </ng-template>
          </laas-data-table>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
